import { useSyncExternalStore } from "react";
import { useNavigate } from "react-router-dom";
import UploadTrayView from "../../common/UploadTrayView";
import { cancelDocumentUpload, clearFinishedDocumentUploads, getDocumentUploads, subscribeDocumentUploads } from "../../../services/agencyDocumentUploadService";

// Bottom-right progress tray for policy documents being uploaded and
// processed. Mounted once in the agency dashboard so it survives tab changes.
const DocumentUploadTray: React.FC = () => {
  const items = useSyncExternalStore(subscribeDocumentUploads, getDocumentUploads);
  const navigate = useNavigate();
  return (
    <UploadTrayView
      items={items.map((i) => ({
        id: i.id,
        name: i.name,
        status: i.status,
        progress: i.progress,
        error: i.error,
        doneLabel: i.after,
        onOpen: i.openPath ? () => navigate(i.openPath!) : undefined,
      }))}
      onClearFinished={clearFinishedDocumentUploads}
      activeHint="Keep this tab open until the upload finishes. After that the document is read, split into sections, and tagged on our servers."
      finishedHint="Your documents are ready. Click a name to review its sections and tags."
      finishedVerb="Finished"
      onCancel={cancelDocumentUpload}
    />
  );
};

export default DocumentUploadTray;
